import React from "react";

// Decorative SVG: Metatron-style sacred geometry. Pure CSS / SVG, no deps.
export const SacredGeometry = ({ className = "", strokeOpacity = 0.35 }) => (
  <svg
    aria-hidden
    viewBox="0 0 600 600"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="sg-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.25" />
        <stop offset="60%" stopColor="#6A0DAD" stopOpacity="0.05" />
        <stop offset="100%" stopColor="#060A14" stopOpacity="0" />
      </radialGradient>
    </defs>
    <circle cx="300" cy="300" r="280" fill="url(#sg-glow)" />
    <g stroke="#D4AF37" strokeWidth="0.6" strokeOpacity={strokeOpacity}>
      <circle cx="300" cy="300" r="120" />
      <circle cx="300" cy="180" r="120" />
      <circle cx="300" cy="420" r="120" />
      <circle cx="404" cy="240" r="120" />
      <circle cx="196" cy="240" r="120" />
      <circle cx="404" cy="360" r="120" />
      <circle cx="196" cy="360" r="120" />
      <circle cx="300" cy="300" r="220" />
      <circle cx="300" cy="300" r="260" />
      <polygon points="300,80 520,440 80,440" />
      <polygon points="300,520 80,160 520,160" />
    </g>
  </svg>
);

export default SacredGeometry;
